module.exports = __webpack_public_path__ + "static/media/badge-remove.c5a5c829.svg";